import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Notiflix from "notiflix";
import PostApiCall from "../../Api";
// import GetApiCall from '../../GetApi';
import moment from "moment";
import ReactStars from "react-rating-stars-component";

const ImgUpload = ({ onChange, src }) => (
	<label htmlFor="photo-upload" className="custom-file-upload fas">
		<div className="img-wrap img-upload">
			<img
				for="photo-upload"
				src={src}
				style={{ width: "100%", height: "100%", borderRadius: "5%" }}
			/>
		</div>
		<input accept="image/*" id="photo-upload" type="file" onChange={onChange} />
	</label>
);

class AddUser extends Component {
	constructor(props) {
		super(props);
		this.state = {
			imagePreviewUrl:
				"https://www.adcproductdesign.com/wp-content/uploads/2018/02/Realize-Icon-Blue.png",
			ImageApiUrl: `${JSON.parse(localStorage.getItem("ClientDetails"))[0].fld_apiaddress} + /AddImage`,
			Status: "Active",
			ImageData: [],
			Name: "",
			Feedback: "",
			Rating: JSON.parse(localStorage.getItem("ReviewDetails")).fld_rating,
			TestimonialId: "",
		};
	}

	componentDidMount() {
		Notiflix.Loading.Init({
			svgColor: "#777f80",
		});

		var det = localStorage.getItem("ReviewDetails");
		var ReviewData = JSON.parse(det);

		// //console.log(ReviewData)

		if (ReviewData.fld_clientimage != null) {
			this.setState({
				imagePreviewUrl: ReviewData.fld_clientimage,
			});
		} else {
			this.setState({
				imagePreviewUrl:
					"https://www.adcproductdesign.com/wp-content/uploads/2018/02/Realize-Icon-Blue.png",
			});
		}

		this.setState({
			Name: ReviewData.fld_clientname,
			Feedback: ReviewData.fld_description,
			Rating: ReviewData.fld_rating,
			TestimonialId: ReviewData.fld_reviewid,
			Status: ReviewData.fld_status,
		});
	}

	photoUpload = (e) => {
		e.preventDefault();
		if (e.target.files[0].size < 300000) {
			const reader = new FileReader();
			const file = e.target.files[0];
			reader.onloadend = () => {
				this.setState({
					file: file,
					imagePreviewUrl: reader.result,
					ImageData: file,
				});
			};
			reader.readAsDataURL(file);
		} else {
			Notiflix.Notify.Failure("File too large, upload file less than 300 kb.");
		}
	};

	onSaveData() {
		if (this.state.Name != "") {
			if (this.state.Rating !== 0) {
				if (this.state.Feedback != "") {
					if (this.state.Status != "") {
						this.onPost();
					} else {
						Notiflix.Notify.Failure(
							"Please specify whether to the review should be visible on the website."
						);
					}
				} else {
					Notiflix.Notify.Failure("Please enter customer feedback / review");
				}
			} else {
				Notiflix.Notify.Failure("Please select customer rating");
			}
		} else {
			Notiflix.Notify.Failure("Please enter customer name");
		}
	}

	onPost = () => {
		Notiflix.Loading.Dots("Please wait...");

		var login = localStorage.getItem("LoginDetail");
		var details = JSON.parse(login);
		PostApiCall.postRequest(
			{
				id: this.state.TestimonialId,
				name: this.state.Name,
				feedback: this.state.Feedback,
				rating: this.state.Rating,
				status: this.state.Status,
				updated_on: moment().format("YYYY-MM-DD"),
				updated_by: details[0].fld_userid,
			},
			"UpdateTestimonial"
		).then((resultcategory) =>
			resultcategory.json().then((obj) => {
				if (resultcategory.status == 200 || resultcategory.status == 201) {
					if (
						JSON.stringify(this.state.ImageData) != "[]" &&
						this.state.ImageData != undefined
					) {
						const form = new FormData();
						form.append("file", this.state.ImageData);
						form.append("foldername", "Testimonial");
						form.append(
							"filename",
							this.state.Name.trim().replace(/\s/g, "-") +
							"-" +
							JSON.parse(JSON.stringify(obj.data[0])).TestimonialId
						);

						fetch(this.state.ImageApiUrl, {
							method: "POST",
							body: form,
						}).then((image) => {
							image
								.json()
								.then((data) => ({
									data: data,
									status: image.status,
								}))
								.then((res) => {
									PostApiCall.postRequest(
										{
											testimonialId: JSON.parse(JSON.stringify(obj.data[0]))
												.TestimonialId,
											imageUrl:
												"http://demo.globaltrendz.online/Bechofy/images/Testimonial/" +
												res.data.Message.split(",")[2].split("=")[1].trim(),
										},
										"AddTestimonialImage"
									).then((results1) =>
										results1.json().then((obj1) => {
											if (results1.status == 200 || results1.status == 201) {
												// //console.log(obj1)
												Notiflix.Loading.Remove();
												Notiflix.Notify.Success(
													"Testimonial successfully updated."
												);

												window.location.href = "/review-list";
											}
										})
									);
								});
						});
					} else if (
						this.state.imagePreviewUrl !=
						"https://www.adcproductdesign.com/wp-content/uploads/2018/02/Realize-Icon-Blue.png"
					) {
						//   //console.log('uploaded image')

						PostApiCall.postRequest(
							{
								testimonialId: JSON.parse(JSON.stringify(obj.data[0]))
									.TestimonialId,
								imageUrl: this.state.imagePreviewUrl,
							},
							"AddTestimonialImage"
						).then((results1) =>
							results1.json().then((obj1) => {
								if (results1.status == 200 || results1.status == 201) {
									// //console.log(obj1)
									Notiflix.Loading.Remove();
									Notiflix.Notify.Success("Testimonial successfully updated.");

									window.location.href = "/review-list";
								}
							})
						);
					}
				} else {
					Notiflix.Loading.Remove();
					Notiflix.Notify.Success("Testimonial successfully updated.");

					window.location.href = "/review-list";
				}
			})
		);
	};

	render() {
		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						{/* Render Breadcrumb */}
						<Breadcrumbs
							title={"Bechofy / Review Management / Review List "}
							breadcrumbItem={"Edit Review"}
						/>

						<Row>
							<Col xl="12">
								<Card className="overflow-hidden">
									<div
										className="Bechofy-bg-soft-pink"
										style={{ background: "#777f80" }}
									>
										<Row>
											<Col xs="6">
												<div className="Bechofy-text p-3">
													<h5 className="Bechofy-text text-white">
														Review Management
													</h5>
												</div>
											</Col>
										</Row>
									</div>
									<Card className="overflow-hidden">
										<div className="Bechofy-bg-soft-pink">
											<Row>
												<Col xs="3">
													<div className="Bechofy-text  p-3">
														<h5 className="Bechofy-text">
															Edit Review
														</h5>
													</div>
												</Col>
											</Row>
										</div>
										<CardBody className="pt-0">
											<Row>
												<Col xs="12">
													<div className="form my-4">
														<div className="row">
															<div className="col col-12">
																<div className="row">
																	<div className="col-md-4">
																		<label for="sw-arrows-first-name">
																			Upload Image (Size &lt; 100kb, 500*500)
																			<span className="mandatory">*</span>
																		</label>
																		<div class="div1">
																			<ImgUpload
																				onChange={this.photoUpload}
																				src={this.state.imagePreviewUrl}
																			/>
																		</div>
																	</div>

																	<div className="col-md-8">
																		<div className="row">
																			<div className="col-6">
																				<div className="form-group">
																					<label for="CategoryName">
																						Name
																						<span className="mandatory">*</span>
																					</label>
																					<input
																						type="text"
																						id="CategoryName"
																						className="form-control my-1 mr-sm-2"
																						value={this.state.Name}
																						onChange={(text) => {
																							this.setState({
																								Name: text.target.value,
																							});
																						}}
																					/>
																				</div>
																			</div>

																			<div className="col-6">
																				<div className="form-group">
																					<label for="CategoryName">
																						Rating
																						<span className="mandatory">*</span>
																					</label>
																					<ReactStars
																						count={5}
																						onChange={(rating) => {
																							this.setState({
																								Rating: rating,
																							});
																						}}
																						value={this.state.Rating}
																						size={22}
																						fullIcon={
																							<i className="fa fa-star"></i>
																						}
																						activeColor="#ffd700"
																						style={{ padding: "6px!important" }}
																					/>
																				</div>
																			</div>

																			<div className="col-12">
																				<div className="form-group">
																					<label for="CategoryName">
																						Feedback
																						<span className="mandatory">*</span>
																					</label>
																					<textarea
																						required
																						rows={5}
																						type="text"
																						class="form-control"
																						id="validationCustom05"
																						value={this.state.Feedback}
																						onChange={(text) => {
																							this.setState({
																								Feedback: text.target.value,
																							});
																						}}
																					/>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</Col>
											</Row>
										</CardBody>
									</Card>
									<Card>
										<CardBody className="py-1    my-1">
											<Row>
												<Col xs="12">
													<div className="row">
														<div className="col-6">
															<div className="form-group my-1 mr-sm-2">
																<label for="CategoryName">
																	Review Status
																	<span className="mandatory">*</span>
																</label>
																<br />
																<label class="radio-inline">
																	<input
																		type="radio"
																		name="optradio"
																		//  disabled={!this.state.IsVisible}
																		checked={
																			this.state.Status == "Active"
																				? true
																				: false
																		}
																		onChange={() => {
																			this.setState({
																				Status: "Active",
																			});
																		}}
																	/>{" "}
																	Yes
																</label>
																<label
																	class="radio-inline"
																	style={{ marginLeft: "10px" }}
																>
																	<input
																		type="radio"
																		name="optradio"
																		//  disabled={!this.state.IsVisible}
																		checked={
																			this.state.Status == "Inactive"
																				? true
																				: false
																		}
																		onChange={() => {
																			this.setState({
																				Status: "Inactive",
																			});
																		}}
																	/>
																	No
																</label>
															</div>
														</div>
														<div className="col-6">
															<button
																style={{ float: "right", marginTop: "15px" }}
																className="btn align-items-center Bechofy-btn "
																onClick={this.onSaveData.bind(this)}
															>
																Update Review
															</button>
														</div>
													</div>
												</Col>
											</Row>
										</CardBody>
									</Card>
								</Card>{" "}
								{/* <WelcomeComp /> */}
							</Col>
						</Row>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}
export default AddUser;
